<ng-container *ngIf="contractRef">
  <div
    *ngIf="isLoading"
    class="row center">
    <div class="col">
      <app-loading-icon
        class="u-color--light"
        size="2x"></app-loading-icon>
    </div>
  </div>
  <div
    *ngIf="!dataSource.data?.length"
    class="row center">
    <div class="col">
      <h2>{{ "contract.nodocumentsfound" | translate }}</h2>
    </div>
  </div>
  <div [hidden]="!dataSource.data?.length">
    <div class="col">
      <div class="o-grid u-pb--medium">
        <div class="o-grid__item col-12 col-md-3 col-sm-5 u-p-bottom-only">
          <form class="c-search-form--full">
            <div class="c-input-group">
              <input
                type="text"
                name="search"
                id="input-search"
                [(ngModel)]="dataSource.filter"
                class="c-input c-input--beta"
                placeholder="{{ localizationConstants.QUICK_GRID_FILTER_SEARCH | translate }}"
                required />
              <input
                *ngIf="dataSource.filter"
                id="contract-detail-search-clear"
                (click)="dataSource.filter = ''"
                class="c-button c-button--search c-close-search c-button--search--sm"
                value="Clear" />
              <input
                *ngIf="!dataSource.filter"
                id="contract-detail-search"
                type="submit"
                class="c-button c-button--search c-button--search--sm"
                value="Search" />
            </div>
          </form>
        </div>
      </div>
      <div
        id="document-list"
        class="col bg-white u-shadow u-scroll--horizontal">
        <div
          id="document-table"
          class="tools-table col">
          <table
            mat-table
            [dataSource]="dataSource"
            matSort
            class="c-table c-table--expandable">
            <ng-container matColumnDef="docId">
              <th
                mat-header-cell
                mat-sort-header
                *matHeaderCellDef
                class="c-table__column-title">
                {{ "contract.documentname" | translate }}
              </th>
              <td
                mat-cell
                *matCellDef="let d">
                {{ d.docId }}
              </td>
            </ng-container>

            <ng-container matColumnDef="additionDate">
              <th
                mat-header-cell
                mat-sort-header
                *matHeaderCellDef
                class="c-table__column-title">
                {{ "contract.documentdate" | translate }}
              </th>
              <td
                mat-cell
                *matCellDef="let d">
                {{ d.additionDate | date }}
              </td>
            </ng-container>

            <ng-container matColumnDef="fileName">
              <th
                mat-header-cell
                mat-sort-header
                *matHeaderCellDef
                class="c-table__column-title">
                {{ "contract.filename" | translate }}
              </th>
              <td
                mat-cell
                *matCellDef="let d">
                <a
                  class="c-download-link"
                  (click)="download(d)">
                  <fa-icon [icon]="faDownload"></fa-icon>
                  {{ d.fileName }}
                </a>
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="['docId', 'additionDate', 'fileName']"></tr>
            <tr
              mat-row
              *matRowDef="let d; columns: ['docId', 'additionDate', 'fileName']"
              class="c-table__row"></tr>
          </table>
        </div>
      </div>
    </div>
    <div class="c-pagination--desktop">
      <div class="col-12">
        <mat-paginator
          [showFirstLastButtons]="true"
          [pageSize]="pageSize"
          [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</ng-container>
